import gql from "graphql-tag";

export default gql`
    mutation ($discountId: ID!) {
        generateDiscountExport (discountId: $discountId) {
            success
        }
    }
`;
